import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ApolloClient, ApolloProvider, HttpLink, InMemoryCache, from } from '@apollo/client'
import {setContext} from '@apollo/client/link/context'
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, matchRoutes } from "react-router-dom";
import { initializeFaro, createReactRouterV6DataOptions, ReactIntegration, getWebInstrumentations } from '@grafana/faro-react';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import "./style/global.css";
import {config} from './config/config'
import {Amplify} from 'aws-amplify'
import {fetchAuthSession} from 'aws-amplify/auth'
import AppProvider from "./Provider/AppProvider";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"
import Helmet from "react-helmet";
import { roles } from "./helper";
   
Amplify.configure(config.amplifyConfig);

initializeFaro({
  url: process.env.REACT_APP_FARO_URL, 
  app: {
    name: process.env.REACT_APP_FARO_APP_NAME,           
    version: process.env.REACT_APP_FARO_APP_VERSION,               
    environment: process.env.REACT_APP_FARO_ENV        
  },
  instrumentations: [
    ...getWebInstrumentations(),
    new TracingInstrumentation(),
    new ReactIntegration({
      router: createReactRouterV6DataOptions({ matchRoutes }),
    }),
  ],
});

const container = document.getElementById("root");
const root = createRoot(container!);

const getNewAccessToken = async () => {
  return fetchAuthSession({forceRefresh: true})
};

const setAuthorizationLink = setContext(
  async (request: any, previousContext: any) => {
    let idToken: any = localStorage.getItem(Object.keys(localStorage).find((key) => key.includes('idToken')) as string) || '';
    if (idToken) {
      const jwtPayload = JSON.parse(window.atob(idToken.split('.')[1]));
      const isExpired = Date.now() >= jwtPayload.exp * 1000;
      if (isExpired) {
        await getNewAccessToken()
        .then((data)=>{
          idToken = localStorage.getItem(Object.keys(localStorage).find((key) => key.includes('idToken')) as string); 
        })
      }
    }
    return _buildAuthHeader(idToken);
  }
);


const _buildAuthHeader = (token: string) => {
  const hasuraRole = localStorage.getItem('x-hasura-user-role');
  const isSuperUser= hasuraRole===roles.SUPER_USER;
  return {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
      ...(isSuperUser ? {"x-hasura-role":hasuraRole}:{})
    },
  };
};

const httpLink = new HttpLink({ uri: config.backend_url });
const client = new ApolloClient({
  link: from([setAuthorizationLink, httpLink]),
  cache: new InMemoryCache({
    addTypename: false
  }),
});

root.render(
  <>
  <Helmet>
  <meta name="robots" content="noindex"></meta>
  </Helmet>
  <BrowserRouter>
  <ApolloProvider client={client}>
    <AppProvider>
    <App />
    </AppProvider>
  </ApolloProvider>
  </BrowserRouter>
  </>
);
serviceWorkerRegistration.register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
